import * as React from 'react';

import LayerTrigger, { Alignment, Placement } from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';
/**
 * [LayerTrigger](/internal/components/LayerTrigger) for [Tooltips](/internal/components/Tooltip).
 *
 *
 * ```example
 * <TooltipTrigger tooltip="Tooltip">
 *   <Button>Click</Button>
 * <TooltipTrigger/>
 * ```
 *
 * ```example
 * <TooltipTrigger
 *   placement="top"
 *   tooltip={<Tooltip color="mascot">Tooltip</Tooltip>}
 *   trigger="hover">
 *   <Button>Click</Button>
 * <TooltipTrigger/>
 * ```
 *
 *
 * # TODO
 * * Allow wrapping of `Text` & similar…wrap body in `span`?
 */
class TooltipTrigger extends React.Component<{
  alignment?: Alignment;
  children?: React.ReactNode;
  placement?: Placement;
  tooltip: React.ReactNode;
}> {
  render() {
    const { alignment, children, placement, tooltip } = this.props;
    const layer: any = (() => {
      if (typeof tooltip === 'string') {
        return <Tooltip>{tooltip}</Tooltip>;
      } else {
        return tooltip;
      }
    })();
    return (
      <LayerTrigger
        layer={layer}
        alignment={alignment}
        delayShow={400}
        placement={placement}
        trigger={['focus', 'hover']}
      >
        {children || null}
      </LayerTrigger>
    );
  }
}
export default TooltipTrigger;
